import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import './Comment.scss'

class Comment extends Component {

    render() {
        let { commentInfo, onRemove, onReport, currentUser, onClickNickname } = this.props;
        const { id, username, comment, date, userid, profileURL, userShareId } = commentInfo;
        return (
            <div className='comment-item'>
                <div className='comment-user-info'>
                    <div className='comment-user-profile' onClick={() => { onClickNickname(userShareId, userid) }} >
                        <img
                            className='comment-user-profile'
                            src={profileURL ? profileURL : "https://front.videomonster.com/images-7cuytg20/common/v2-profile.svg"}
                            alt='user-profile' />
                    </div>
                    <div className='comment-user-nickname' onClick={() => { onClickNickname(userShareId, userid) }} >
                        {username}
                    </div>
                    <div className='comment-function-area'>
                        {
                            currentUser && currentUser._id === userid ?
                                <div className='comment-function'>
                                    <div className='remove-btn' onClick={() => onRemove(commentInfo)}>
                                        <img src="https://front.videomonster.com/images-7cuytg20/web/myvideofooter/outline-delete.svg" alt="deleteIcon" />
                                    </div>
                                </div>
                                :
                                <div className='comment-function'>
                                    <div className='report-btn' width={"12px"} onClick={() => onReport(commentInfo)}>
                                        <img src="https://front.videomonster.com/images-7cuytg20/web/sharedLinkPage/reportIcon.png" alt="deleteIcon" />
                                    </div>
                                </div>

                        }
                    </div>
                </div>
                <div className='comment-info'>
                    <div className='comment-data'>
                        {comment}
                    </div>
                    <div className='comment-date'>
                        {dayjs(date).format("YYYY.MM.DD")}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,

})

export default connect(
    mapStateToProps,
    null
)(Comment)